import { render, staticRenderFns } from "./DialogueStopBankVote.vue?vue&type=template&id=a96f1800&scoped=true"
import script from "./DialogueStopBankVote.vue?vue&type=script&lang=ts"
export * from "./DialogueStopBankVote.vue?vue&type=script&lang=ts"
import style0 from "./DialogueStopBankVote.vue?vue&type=style&index=0&id=a96f1800&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96f1800",
  null
  
)

export default component.exports